<template>
  <div class="container">
    <router-view />
  </div>
</template>

<script>
import WOW from 'wow.js/dist/wow.min.js'

export default {
  name: 'App',
  mounted() {
    this.$nextTick(() => {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 100,
        mobile: true,
        live: true
      })
      wow.init()
      console.log('Wow.js a été initialisé.')
    })
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
